import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { App, Tag } from '../app.models';
import { selectCustomerApiEndpoint, selectRouteParams } from '../app.selector';

@Component({
  selector: 'app-box-subscribers',
  templateUrl: './box-subscribers.component.html'
})
export class BoxSubscribersComponent implements OnInit {
  subscribers$: Observable<any>;
  @Input() type: 'app' | 'tag';
  @Input() entity: App | Tag | any;

  constructor(
    private store: Store,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    const context$ = this.store.select(selectCustomerApiEndpoint).pipe(
      filter((c) => !!c),
      withLatestFrom(this.store.select(selectRouteParams)),
    );

    this.subscribers$ = context$.pipe(
      switchMap(([endpoint, params]) => this.http.get(`${endpoint}/stats/${this.type}/${params['id']}`))
    );
  }
}
